import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

function SEO({ description, lang, meta, title, imageprop, pathname }) {
    const { site } = useStaticQuery(
        graphql`
        query {
          site {
            siteMetadata {
                siteUrl
              title
              description
              author
              keywords
              image
            }
          }
        }
      `
    )
    const image = imageprop ? `${site.siteMetadata.siteUrl}${imageprop}` : `${site.siteMetadata.siteUrl}${site.siteMetadata.image}`
    const keywords = site.siteMetadata.keywords
    const metaDescription = description || site.siteMetadata.description
    const defaultTitle = site.siteMetadata?.title

    const canonical = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : null

    return (
        <>
            {/*<!-- Primary Meta Tags -->*/}
            <title>{(defaultTitle ? title + " | " + defaultTitle : null)}</title>
            <meta id="title" name="title" content={(defaultTitle ? title + " | " + defaultTitle : null)} />
            <meta id="description" name="description" content={metaDescription} />

            {/*<!-- Open Graph / Facebook -->*/}
            <meta id="og:type" property="og:type" content="website" />
            <meta id="og:url" property="og:url" content={canonical} />
            <meta id="og:title" property="og:title" content={(defaultTitle ? title + " | " + defaultTitle : null)} />
            <meta id="og:description" property="og:description" content={metaDescription} />
            <meta id="og:image" property="og:image" content={image} />

            {/*<!-- Twitter -->*/}
            <meta id="twitter:card" property="twitter:card" content="summary_large_image" />
            <meta id="twitter:url" property="twitter:url" content={canonical} />
            <meta id="twitter:title" property="twitter:title" content={(defaultTitle ? title + " | " + defaultTitle : null)} />
            <meta id="twitter:description" property="twitter:description" content={metaDescription} />
            <meta id="twitter:image" property="twitter:image" content={image}></meta>
            <meta id="twitter:creator" property='twitter:creator' content='@davz_official' />
            <meta id="keywords" name='keywords' content={keywords} />

            <link id="canonical" rel="canonical" href={canonical} />

            {/* <script id="overseer" async defer data-website-id="553a2277-e40a-404e-b8e0-6d31b2802d85" src="https://analytics.tierify.app/overseer.js"></script> */}

        </>
    )
}

export default React.memo(SEO);